import { gql } from '@apollo/client';

//Queries
export const LOGIN_USER = gql`
    query loginUser($urlIdentity:String!, $password:String!, $role:String!) {
        loginUser(urlIdentity:$urlIdentity, password:$password, role:$role) {
            token
        }
    }
`;

